import React from 'react';
import { Star } from 'lucide-react';
import { testimonialsData } from '../data/mock';

const TestimonialsSection = () => {
  return (
    <section className="testimonials-section py-20 md:py-32 relative overflow-hidden">
      <div className="testimonials-bg absolute inset-0 z-0"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-6xl font-bold mb-6">
            {testimonialsData.title}
          </h2>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto opacity-80">
            Join hundreds of happy customers who love our treats
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {testimonialsData.testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card rounded-3xl p-8">
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, index) => (
                  <Star key={index} className="h-5 w-5 testimonial-star" fill="currentColor" />
                ))}
              </div>
              
              <p className="text-lg mb-6 leading-relaxed">
                "{testimonial.text}"
              </p>
              
              <div className="testimonial-author">
                <div className="testimonial-avatar">
                  {testimonial.name.charAt(0)}
                </div>
                <p className="font-semibold">
                  {testimonial.name}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
